<template>
    <div class="container-fluid">
        <ToastTemplet :bus="toast"></ToastTemplet>
        <div class="row mt-5">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Applicant List</h3>

                <div class="card-tools">
                    <input class="btn search_box" type="text" placeholder="Login Id" @keyup="searchit" v-model="search" aria-label="Search">
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                        <tr>
                            <th>Login Id</th>
                            <th>Bank Name</th>
                            <th>Product Name</th>
                            <th>Applicant Name</th>
                            <th>Residential Address</th>
                            <th>Contact Person Mobile Number</th>
                            <th>Office Address</th>
                            <th>Office Mobile Number</th>
                            <th>Modify</th>
                        </tr>
                        <tr v-for="(client_master) in client_masters.data" :key="client_master.CLIENT_ID">
                            <td> {{ client_master.Login_Id}} </td>
                            <td> {{ client_master.Bank_Name}} </td>
                            <td> {{ client_master.Product_Name}} </td>
                            <td> {{ client_master.Applicant_Name}} </td>
                            <td> {{ client_master.Residential_Address}} </td>
                            <td> {{ client_master.Contact_Person_Mobile_Number}} </td>
                            <td> {{ client_master.Office_Address}} </td>
                            <td> {{ client_master.Office_Mobile_Number}} </td>
                            <td>
                                <a href="#" @click="restoreProduct(client_master.CLIENT_ID)"><i class="fas fa-recycle green"></i></a>
                            </td>
                        </tr>
                        </table>
                    </div>
                    <!-- /.card-body -->
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-md-9">
                                    <pagination :data="client_masters" @pagination-change-page="loadAndSearchTrashClient" :limit="this.$PaginationCounterLimit">
                                    <span slot="prev-nav">&lt; Previous</span>
                                    <span slot="next-nav">Next &gt;</span>
                                </pagination>
                            </div>
                            <div class="col-md-1 show-text">
                                Show
                            </div>
                            <div class="col-md-1 pagination">
                                <multiselect
                                    v-model="$PaginationLimit"
                                    :options="this.$PaginationOptions"
                                    :allow-empty="false"
                                    open-direction="top"
                                    :show-labels="false"
                                    @input="loadAndSearchTrashClient(1)"
                                    aria-required="true">
                                </multiselect>
                            </div>
                            <div class="col-md-1 entries-text">
                                Entries
                            </div>
                        </div>
                    </div>
                    </div>
                    <!-- /.card -->
                </div>
                </div><!-- /.row -->
    </div>
</template>

<script>
    import ToastTemplet from "../widget/toast";
    export default {
        components: { Multiselect,ToastTemplet },
        data(){
            return{
                toast: new Vue(),
                search:'',
                client_masters:{},
            }
        },
        created() {
            Fire.$on('searching',()=>{
                this.loadAndSearchTrashClient();
            })
            Fire.$on('AfterChangeClient',()=>{
                this.loadAndSearchTrashClient();
            });
        },
        mounted(){
            this.loadAndSearchTrashClient();
        },
        methods:{
            searchit: _.debounce(()=>{
                Fire.$emit('searching');
            },500),
            restoreProduct(CLIENT_ID){
                Swal.fire({
                    title: 'Are you sure Restore It?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                    }).then((result) => {
                        if(result.value){
                            axios.get('restoreClient/'+CLIENT_ID).then(()=>{
                                Fire.$emit('AfterChangeClient');
                                this.toast.$emit('SwalSuccess',"Success!", "Client Restore successfully.");

                            }).catch(()=>{
                                this.toast.$emit('SwalWarning',"Failed!", "There was something wrong, Or Client Is Already In Use");
                            })
                        }
                    })
            },
            loadAndSearchTrashClient(page = 1) {
                this.toast.$emit('ProgressBarLoading');
                axios
                    .get("loadAndSearchTrashClient?query=" + this.search +"&page=" + page + "&PaginationLimit="+ this.$PaginationLimit)
                    .then(({ data }) => {
                        this.client_masters = data,
                        this.toast.$emit('ProgressBarFinish')
                    })
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any Such User");
                    });
            },
        }
    }
</script>
